'use client';

import { useContactModal } from '@/contexts/ContactModalContext';
import NavigationContactModal from './NavigationContactModal';

export default function ContactModalWrapper() {
  const { isOpen, closeModal } = useContactModal();

  return (
    <NavigationContactModal 
      isOpen={isOpen} 
      onClose={closeModal} 
    />
  );
}

